import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchDataSolicitacaoById } from '@hooks/api/Solicitacao/useFetchDataSolicitacaoById.js';
import { FormProvider, useForm } from 'react-hook-form';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { useFetchDataByProcessoUnidade } from '@hooks/api/Solicitacao/useFetchDataByProcessoUnidade.js';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';
import ViewerSection from '@components/Solicitacao/User/Responder/Sections/ViewerSection/Index';
import ItensProcessoSection from '@components/Solicitacao/User/Responder/Sections/ItensProcessoSection/Index';
import ButtonActions from '@components/Solicitacao/User/Responder/Sections/ButtonActions/Index';
import StatusSolicitacaoSection from '@components/Solicitacao/Shared/Sections/StatusSection/Index';
import SolicitacaoHistoricoSection from '@components/Solicitacao/Shared/Sections/HistoricoSection/Index';

const ResponderSolicitacao = () => {
  const { id } = useParams();
  const { solicitacaoFields, loading, error } = useFetchDataSolicitacaoById(id);
  const [solicitacaoProcessoItems, setSolicitacaoProcessoItems] = useState([]);

  useEffect(() => {
    if (solicitacaoFields?.solicitacaoProcessoItems) {
      setSolicitacaoProcessoItems(solicitacaoFields.solicitacaoProcessoItems);
    }
  }, [solicitacaoFields]);

  const {
    relatorios,
    planosAcao,
    loadingDocs,
    errorDocs,
  } = useFetchDataByProcessoUnidade(
    solicitacaoFields?.compliance?.idProcesso,
    solicitacaoFields?.unidadeGerencia?.id
  );

  const navigate = useNavigate();

  const defaultValues = useMemo(() => ({
    numeroSolicitacao: solicitacaoFields?.numeroSolicitacao,
    emailCC: solicitacaoFields?.emailCC,
    idTemplateEmailComunicado: solicitacaoFields?.templateEmailComunicado?.value || null,
    idTemplateEmailSolicitacao: solicitacaoFields?.templateEmailSolicitacao?.value || null,
    idTemplateEmailRelatorio: solicitacaoFields?.templateEmailRelatorio?.value || null,
    idAuditor: solicitacaoFields?.auditor?.id,
    dataSolicitacao: solicitacaoFields?.dataSolicitacao,
    prazoSolicitacao: solicitacaoFields?.prazoSolicitacao,
    dataLimiteSolicitacao: solicitacaoFields?.dataLimiteSolicitacao,
    dataAgendarEnvio: solicitacaoFields?.dataAgendarEnvio || null,
    observacoes: solicitacaoFields?.observacoes,
    solicitacaoProcessoItems: solicitacaoProcessoItems,
    statusSolicitacao: solicitacaoFields?.statusSolicitacao
  }), [solicitacaoFields, solicitacaoProcessoItems]);

  const methods = useForm({ defaultValues });

  const isReady = !loading && !loadingDocs && solicitacaoFields;

  if (error || errorDocs) {
    return (
      navigate('/404')
    );
  }

  if (!isReady) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <CustomLoader text={"Carregando os dados da solicitação..."}/>
      </div>
    );
  }

  return (
    <PageWrapper>
      <FormProvider {...methods}>
        <div>

          {/* Campos de visualização exclusiva para usuários das unidades/gerencias */}
          <ViewerSection
            solicitacaoFields={solicitacaoFields}
            loading={loading}
            error={error}
          />

          {/* Itens do Processo definidos pelo auditor associados a solicitação de uma unidade/gerencia */}
          <ItensProcessoSection
            solicitacaoFields={solicitacaoFields}
            solicitacaoProcessoItems={solicitacaoProcessoItems}
            setSolicitacaoProcessoItems={setSolicitacaoProcessoItems}
          />

          {/*  Botões de açãos para responder uma solicitação de acordo com o status */}
          <ButtonActions
            methods={methods}
            solicitacaoFields={solicitacaoFields}
            relatorios={relatorios}
            planosAcao={planosAcao}
            solicitacaoProcessoItems={solicitacaoProcessoItems}
          />

          {/*  Status da Solicitação */}
          <StatusSolicitacaoSection
            solicitacaoFields={solicitacaoFields}
          />

          {/*  Histórico da Solicitação */}
          <SolicitacaoHistoricoSection
            solicitacaoFields={solicitacaoFields}
          />

        </div>
      </FormProvider>
    </PageWrapper>
  );
}

export default ResponderSolicitacao;